import { Border } from '../page-components/border.model';
import { Margin } from '../page-components/margin.model';
import { Padding } from '../page-components/padding.model';

export class Header {
  Type: number = 0;
  Height?: string | null;
  FullWidth: boolean = false;
  ShowAnimation: boolean = false;
  ShowLogo: boolean = false;
  AlignmentType?: string | null;
  Color: string = '';
  ColorHoover: string = '';
  BackgroundColor: string = '';
  FontSize?: string | null;
  HeadingType?: string | null;
  Links: HeaderLinks[] = [];
  BackgroundActiveColor?: string | null;
  BorderColor?: string | null;
  MobileMenuBackgroundColor: string = '';
  MobileMenuColor: string = '';
  HamburgerColor: string = '';
  FixedDesktop: boolean = false;
  FixedTablet: boolean = false;
  FixedMobile: boolean = false;
  StickyDesktop: boolean = false;
  StickyTablet: boolean = false;
  StickyMobile: boolean = false;
  Shadow: boolean = false;
  Padding: Padding = new Padding();
  Margin: Margin = new Margin();
  Border: Border = new Border();
  HeaderTop: HeaderTop = new HeaderTop();
  Styles?: string[];
  MobileMenuPosition: string = 'left';
}

export class HeaderLinks {
  Name: string = '';
  Url: string = '';
  ExternalLink: boolean = false;
  Children: HeaderLinkChildren[] = [];
}

export class HeaderLinkChildren {
  Name: string = '';
  Url: string = '';
  ExternalLink: boolean = false;
}

export class HeaderTop {
  Display: boolean = false;
  Links: HeaderLinks[] = [];
  BackgroundColor: string = '';
  Color: string = '';
  ColorHoover: string = '';
  HideOnScroll: boolean = false;
  ShowSocialMediaLinks: boolean = false;
  ContactPhoneNumber: string = '';
  ContactPhoneNumberText: string = '';
  ContactEmail: string = '';
  ContactEmailText: string = '';
}
